module.exports = __webpack_public_path__ + "img/coupon_flower.19360573.png";